const Notas = () => import('@/spa/notas/Notas');
const NotasListNivel1 = () => import('@/spa/notas/NotasNivel1');

export default {
  path: 'notas',
  component: Notas,
  children: [
    {
      path: '',
      name: 'notas',
      component: NotasListNivel1,
    },
  ],
};
